import { InjectedConnector } from "@web3-react/injected-connector";
import { NetworkConnector } from "@web3-react/network-connector";
import { chainIds, chainUrls } from "./config";

export const injectedConnector = new InjectedConnector({
  supportedChainIds: [chainIds.MAINNET, chainIds.LOCAL, chainIds.RINKEBY, chainIds.GOERLI],
});

export const networkConnector = new NetworkConnector({
  urls: {
    [chainIds.LOCAL]: chainUrls.LOCAL,
    [chainIds.MAINNET]: chainUrls.MAINNET,
    [chainIds.ROPSTEN]: chainUrls.ROPSTEN,
    [chainIds.RINKEBY]: chainUrls.RINKEBY,
    [chainIds.GOERLI]: chainUrls.GOERLI,
  },
  defaultChainId: 1,
});
